import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { SesionService } from 'core-tsi';

export const hasAccessGuard: CanMatchFn = () => {
  const router = inject(Router)
  const sesionService = inject(SesionService)
  const sesion = sesionService.getSession();
  const isLogin = sesion && sesion.token
  return isLogin ? true : router.createUrlTree(['/login']);
};
